import * as React from "react";

export const IconPlaylistAddCheck = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_6332_11216)">
			<path
				d="M11.666 8.33333L1.66602 8.33333L1.66602 10L11.666 10V8.33333ZM11.666 5L1.66602 5L1.66602 6.66667L11.666 6.66667V5ZM1.66602 13.3333L8.33268 13.3333L8.33268 11.6667H1.66602L1.66602 13.3333ZM17.916 9.58333L19.166 10.8333L13.341 16.6667L9.58268 12.9167L10.8327 11.6667L13.341 14.1667L17.916 9.58333Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_6332_11216">
				<rect width="20" height="20" fill="currentColor" />
			</clipPath>
		</defs>
	</svg>
);
